// Chequeo de vencimiento de versión (solo aplica al destinatario 5).
// configuracion.versionWeb viene con el formato "dia.añoCorto.mes"
// (año corto de 1 dígito, ej. "6" -> 2026).
//
// Se centraliza acá porque más de una pantalla necesita la misma regla:
// Barra.js la usa para ocultar el menú, Logo.js para ocultar/deshabilitar
// los accesos directos. Antes vivía solo adentro de Barra.js.
export function versionVencida(configuracion) {
  if (
    !configuracion ||
    configuracion.destinatario !== 5 ||
    !configuracion.versionWeb
  ) {
    return false;
  }

  const [dia, anioCorto, mes] = configuracion.versionWeb.split(".");
  const tope = new Date(`202${anioCorto}`, mes - 1, dia);

  return Date.now() > tope.getTime();
}
